<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
	<div class="row my-4">
		<div *ngIf="form.contains('nomStructure')" class="col-12 col-lg">
			<label for="nomStructure" class="form-label theme-main-color fw-bold"
				>Nom de la structure</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="nomStructure"
				name="nomStructure"
				formControlName="nomStructure"
				[ngClass]="{
					'is-invalid': nomStructure.invalid,
					'is-valid': nomStructure.dirty && nomStructure.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="typeStructure" class="form-label fw-bold"
				>Type de structure</label
			>
			<select
				id="typeStructure"
				class="form-select"
				name="typeStructure"
				formControlName="typeStructure"
				>
				<option *ngFor="let typeStructure of listTypeStructure" value="{{ typeStructure.id }}">
					{{ typeStructure.name}}
				</option>
			</select>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('addressStructure')" class="col-12 col-lg">
			<label for="addressStructure" class="form-label theme-main-color fw-bold"
				>Adresse</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="addressStructure"
				name="addressStructure"
				[typeahead]="addressList"
				[typeaheadAsync]="true"
				typeaheadOptionField="displayName"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				formControlName="addressStructure"
				(keyup)="selectedAddressKeyUp($event.target)"
				(typeaheadOnSelect)="onAddressSelect($event)"
			/>
		</div>
	</div>

	<div class="row">
		<span class="theme-main-color fs-4 col">Contacts</span>
	</div>

	<div class="row my-5">
		<div class="d-flex justify-content-start">
			<button
				*ngIf="form.get('contacts')"
				class="btn theme-green-button"
				type="button"
				(click)="onAddContact()"
				>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Ajouter un contact
			</button>
		</div>
	</div>

	<div formArrayName="contacts">
		<div *ngFor="let row of contactsPrescripteur.controls; let pointIndex = index;" [formGroupName]="pointIndex">
		<div class="row my-4">
			<div class="col-12 col-lg">
				<label for="firstName" class="form-label theme-main-color fw-bold"
					>Prénom</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					id="firstName"
					name="firstName"
					formControlName="firstName"
				/>
			</div>
			<div class="col-12 col-lg">
				<label for="lastName" class="form-label theme-main-color fw-bold"
					>Nom</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					id="lastName"
					name="lastName"
					formControlName="lastName"
				/>
			</div>
		</div>
		<div class="row my-4">
			<div class="col-12 col-lg">
				<label for="telephoneStandard" class="form-label theme-main-color fw-bold"
					>Téléphone standard</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					id="telephoneStandard"
					name="telephoneStandard"
					formControlName="telephoneStandard"
				/>
			</div>
			<div class="col-12 col-lg">
				<label for="telephoneFixe" class="form-label theme-main-color fw-bold"
					>Téléphone fixe</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					id="telephoneFixe"
					name="telephoneFixe"
					formControlName="telephoneFixe"
				/>
			</div>
		</div>
		<div class="row my-4">
			<div class="col-12 col-lg">
				<label for="telephonePortable" class="form-label theme-main-color fw-bold"
					>Téléphone portable</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					id="telephonePortable"
					name="telephonePortable"
					formControlName="telephonePortable"
				/>
			</div>
			<div class="col-12 col-lg">
				<label for="email" class="form-label theme-main-color fw-bold"
					>Email</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					id="email"
					name="email"
					formControlName="email"
				/>
			</div>
		</div>
		<div class="row my-4">
			<div class="col-12 col-lg">
				<label for="fonction" class="form-label theme-main-color fw-bold"
					>Fonction</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					id="fonction"
					name="fonction"
					formControlName="fonction"
				/>
			</div>
		</div>
		<div class="">
			<a
				(click)="removeContact(pointIndex)"
				class="btn theme-red-button px-4"
			>
			Supprimer un contact
			</a>
		</div>

	</div>
	</div>

	<div *ngIf="contactsPrescripteur?.length >= 1" class="row my-5">
		<div class="d-flex justify-content-start">
			<button
				*ngIf="form.get('contacts')"
				class="btn theme-green-button"
				type="button"
				(click)="onAddContact()"
				>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Ajouter un contact
			</button>
		</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="
					!form.valid ||
					!(isAddressDefault.value || isAddressSelected.value) ||
					isValidateButtonClicked.value
				"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
